import { hashHistory } from 'react-router';
import {apiRequest} from '../utils/Api';
import {userConstants} from '../constants/ActionTypes';

function request(user) {
  return {type: userConstants.LOGIN_REQUEST, user};
}

function success(data) {
  return {type: userConstants.LOGIN_SUCCESS, data};
}

function failure(error) {
  return {type: userConstants.LOGIN_FAILURE, error};
}

function login(username, passwordHash) {
  return (dispatch) => {
    dispatch(request(username));

    apiRequest(`/users/token`, 'POST', {
      body: JSON.stringify({
        username: username,
        password_hash: passwordHash,
      })
    })
      .then((json) => {
        localStorage.setItem('token', json.data.token);
        localStorage.setItem('user', JSON.stringify(json.data.user));
        dispatch(success(json.data));

        hashHistory.push('app/dashboard');
      })
      .catch((error) => {
        dispatch(failure(error));
      });
  };

}

function logout() {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  return { type: userConstants.LOGOUT };
}

function get(email) {
  return apiRequest(`/users/agreements?email=${email}`, 'GET');
}

function saveAgreements(userId, agreements) {
  return apiRequest(`/users/agreements/${userId}`, 'PUT', {
    body: JSON.stringify({agreements})
  });
}

export const userActions = {
  login,
  logout,
  get,
  saveAgreements,
};



// WEBPACK FOOTER //
// ./actions/user.actions.js